
import {$AjaxJson} from '../lf'
import {$Urlpath,$UrlApipath} from '../config/config'


export const languageRequest = {
    Change(func,tag) {
       $AjaxJson($Urlpath+"Language/Change",{Tag:tag},function (d) {
            func(d)
       })
    },
    UpdateCache(func){
       $AjaxJson($Urlpath+"Language/UpdateCache",{},function (d) {
            func(d)
       })
    },
    GetLanguages(func){
       $AjaxJson($Urlpath+"Language/GetLanguages",{},function (d) {
            func(d)
       })
    }
}










// WEBPACK FOOTER //
// ./src/request/language.js